export default __webpack_public_path__ + "static/media/982.21efb6e2.png";